import React from "react"
import classNames from "classnames"
import { Icon } from "../Icon"
import { FormElementStatus } from "./form"

export interface HintPropsType {
  className?: string
  children: React.ReactNode
  status?: FormElementStatus
}

const ICON_SIZE = 16

const getIcon = (status: FormElementStatus | undefined) => {
  switch (status) {
    case "success": {
      return "checkCircle"
    }
    case "error": {
      return "contextualWarningCircleFilled"
    }
    default: {
      return "info"
    }
  }
}

const getIconColor = (status: FormElementStatus | undefined) => {
  switch (status) {
    case "success": {
      return "green"
    }
    case "error": {
      return "red"
    }
    default: {
      return "graphiteLight"
    }
  }
}

export const Hint = ({ children, status, className }: HintPropsType) => {
  return (
    <div
      className={classNames("cobalt-Hint", className, {
        "cobalt-Hint--success": status === "success",
        "cobalt-Hint--error": status === "error",
      })}
    >
      <span className="cobalt-Hint__Icon">
        <Icon
          source={getIcon(status)}
          size={ICON_SIZE}
          color={getIconColor(status)}
        />
      </span>
      <span className="cobalt-Hint__Message">{children}</span>
    </div>
  )
}
